import { DIETARY_ATTRIBUTES } from '../../../../views/phone-answering/constants';

export default {
  [DIETARY_ATTRIBUTES.DAIRY_FREE]: 'Fără lactate',
  [DIETARY_ATTRIBUTES.HALAL]: 'Halal',
  [DIETARY_ATTRIBUTES.SPICY]: 'Picant',
  [DIETARY_ATTRIBUTES.VEGAN]: 'Vegan',
  [DIETARY_ATTRIBUTES.GLUTEN_FREE]: 'Fără gluten',
  [DIETARY_ATTRIBUTES.VEGETARIAN]: 'Vegetarian',
};
